/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    FILTERS FORM MODULE
\*------------------------------------*/
class FiltersForm {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var elem = $(this);

        // If a primary dropdown field has changed...
        $('.js-primary-filter-dropdown').on('change', function() {
            var self = $(this),
                // Get the new value
                newValue = self.val(),
                // Get the name of the related hidden input
                relatedFieldName = self.data('related-field'),
                // Get the related input element
                //relatedField = self.find('input[name="' + relatedFieldName + '"]'),
                relatedField = document.getElementById(relatedFieldName);
                // Get the related range slider
                //rangeSlider = relatedField.siblings('.js-range-slider').find('[data-module="range-slider"]');
                let rangeSlider = relatedField.previousElementSibling.getElementsByClassName('range-slider__slider')[0];
            
            // If the new value is empty...
            if (rangeSlider && rangeSlider.noUiSlider) {
                if (newValue.toString().length === 0) {
                    rangeSlider.noUiSlider.reset();
                } else {
                    rangeSlider.noUiSlider.set(newValue);
                }
            }

            // Update the hidden input to the new value
            relatedField.value = newValue;
        });
    }
}

export default FiltersForm;